import React from 'react'
import { connect } from 'react-redux'
import { Grid, GridColumn, Segment } from 'semantic-ui-react'
import LKModal, { LKModalContainer, actions as LKModalActions } from '../../shared/LKModal'
import { FakeInput, GridContainer } from '../../shared/StyledComponents'
import { LKHeader, LKButton } from 'loankeeper-common/components'
import { LKIcon } from 'loankeeper-common/components'
import { reactForm, FormField } from '../../shared/reactForm'
import { Files } from 'WebAPI'
import { withLookups, colors, withUserConfig, withConstantPermissions } from 'shared'
import { convertUnicodeToLatin } from '../../../store/utility'
import { editFile, toggleFileVisa, uploadFile } from 'src/store/linkedFiles'
import { EXTENTIONS, MODAL_NAME, MimeTypes } from './constants'
import { translate, translateLKMessage, translateWebMessages } from './helpers'
import { Wrapper } from './styles'
import { translate as Translate } from 'loankeeper-common/helpers'
import { fromBuffer } from 'file-type'

export const open = (args) => LKModalActions.open({ name: MODAL_NAME, ...args })

// @ts-ignore
@LKModalContainer(MODAL_NAME)
// @ts-ignore
@withConstantPermissions(['LFL_VISA as CanChangeVisa'])
// @ts-ignore
@withLookups({ query: ['LFL_FileType as FileTypes'] })
@withUserConfig('PersonalNo')
// @ts-ignore
@connect(null, {
  openError: (message, code, plain, onclose) => LKModalActions.openError(message, code, plain, onclose),
  convertUnicodeToLatin,
  editFile,
  uploadFile,
  toggleFileVisa,
})
// @ts-ignore
@reactForm({
  initialValues: (props) => ({
    Active: true,
    Visa: false,
    Title: '',
    Title_ALT: '',
    FileTypeID: props.FileTypeID || 1,
    FileData1: '',
  }),
})
class FileUpload extends React.Component<any> {
  scanFailed = false
  FileTypes: any
  fileInput: any

  constructor(props) {
    super(props)

    this.FileTypes = this.props.FileTypes.map(({ ID, Title }) => ({ value: ID, text: Title }))
    props.form.setValidateFn(this.validate)

    const { params } = props

    if (params.ID) {
      props.form.initialize({
        Active: params.FActive === 1,
        Visa: params.Visa,
        Title: params.Title,
        Title_ALT: params.Title_ALT,
        FileTypeID: params.TypeID,
      })
    } else {
      this.handleFileTypeChanged()
    }
  }

  state = {
    FileName: '',
    signedPdf: false,
    isLoading: false,
    file: null,
    scanning: false,
  }

  onTranslateAltRequest = async (event) => {
    const { value } = event.target

    if (!value) {
      this.props.form.changeValue('Title_ALT', '')
      return
    }

    const result = await this.props.convertUnicodeToLatin(value)
    if (convertUnicodeToLatin.fulfilled.match(result)) {
      this.props.form.changeValue('Title_ALT', result.payload)
    }
  }

  validate = () => {
    if (this.scanFailed) {
      this.scanFailed = false
      return { FileData1: 'Scan failed!' }
    }

    const ERR_REQUIRED_FIELD = translateLKMessage('ERR_REQUIRED_FIELD')

    const isEmpty = !((this.fileInput && this.fileInput.files.length) || this.state.file)

    // return {
    //   FileData1:
    //     !this.props.params.ID &&
    //     (isEmpty ||
    //       (this.fileInput && this.fileInput.files.length && this.fileInput.files[0].size / 1024 / 1024 > 2) ||
    //       (this.state.file && this.state.file.size / 1024 / 1024 > 2))
    //       ? (isEmpty && ERR_REQUIRED_FIELD) || translateWebMessages('FILE_TOO_LARGE')
    //       : undefined,
    // }
    return {
      FileData1: !this.props.params.ID && isEmpty ? ERR_REQUIRED_FIELD : undefined,
    }
  }

  handleSubmit = () => {
    this.props.form.handleSubmit(this.submit)
  }

  submit = ({ Active, Visa, FileTypeID, Title, Title_ALT }) => {
    const { params, onSuccess, closeModal, linkedFiles, openError } = this.props

    const {
      ID,
      HashSum_FileID_,
      ClientID,
      AppID,
      LoanID,
      CollateralID,
      HashSum_ClientID_,
      HashSum_AppID_,
      HashSum_LoanID_,
      HashSum_CollateralID_,
    } = params

    const prevData = { ...linkedFiles }

    let promise

    if (params.ID) {
      promise = this.props.editFile({
        ID,
        HashSum_FileID_,
        ClientID,
        HashSum_ClientID_,
        Active: Active ? 1 : 0,
        Visa: Visa ? 1 : 0,
        Title,
        Title_ALT,
        TypeID: FileTypeID,
      })
    } else {
      if (this.fileInput.files.length || this.state.file) {
        const re = /(?:\.([^.]+))?$/

        const fileExt = re.exec((this.fileInput.files.length && this.fileInput.files[0].name) || this.state.file.name)

        if (!EXTENTIONS.includes(fileExt[1])) {
          openError(translateWebMessages('INVALID_LFL_EXT'))
          return
        }
      }

      promise = this.props.uploadFile({
        ClientID,
        HashSum_ClientID_,
        AppID,
        HashSum_AppID_,
        LoanID,
        HashSum_LoanID_,
        CollateralID,
        HashSum_CollateralID_,
        FileTypeID,
        Title,
        Title_ALT,
        PersonalNo: params && params.PersonalNo,
        FullName: params && params.FullName,
        FileData1: this.state.file || this.fileInput.files[0],
      })
    }

    return promise
      .then((result) => {
        if (uploadFile.rejected.match(result)) {
          openError(translateWebMessages(result.payload))
        } else {
          closeModal()
          if (onSuccess) {
            if (Visa) {
              this.props
                .toggleFileVisa({
                  ID: result.payload.FileID,
                  HashSum_FileID_: result.payload.HashSum_FileID_,
                  ClientID,
                  HashSum_ClientID_,
                })
                .then(() => {
                  onSuccess()
                })
            } else {
              onSuccess()
            }
          }
        }
      })
      .catch((e) => {
        openError(translateLKMessage(e.Error.Message || e.Error.Text || 'HINT_ERR_TITLE'))
      })
  }

  handleUpload = () => {
    this.setState(
      {
        file: null,
        signedPdf: null,
      },
      () => {
        this.fileInput.click()
      },
    )
  }

  handleScan = () => {
    this.setState({ FileName: '' })
    this.fileInput.value = ''

    const ws = new WebSocket('wss://localhost:8888/scan')

    this.setState({ scanning: true, FileName: 'Scanning...' })

    ws.addEventListener('open', () => {
      ws.send('')
    })

    let scanned = false

    ws.addEventListener('message', (event) => {
      scanned = event.data !== 'Fail'

      ws.close()

      if (!scanned) return

      const byteString = atob(event.data)

      const ab = new ArrayBuffer(byteString.length)

      const ia = new Uint8Array(ab)

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      this.setState({
        file: new File([ab], 'scanned.jpg', { type: 'image/jpeg' }),
        scanning: false,
        FileName: 'Scan succeeded!',
      })
      this.props.form.validate()
    })

    ws.addEventListener('close', () => {
      this.setState({ scanning: false, ...(!scanned ? { FileName: 'Scan failed!' } : {}) })

      this.scanFailed = !scanned
      this.props.form.validate()
    })
  }

  handleFileChange = async (event) => {
    const file = event.target.files[0]
    const re = /(?:\.([^.]+))?$/

    if (file) {
      const fileExt = re.exec(file.name)[1]
      const arrayBuffer = await file.arrayBuffer()
      if (arrayBuffer.byteLength === 0) {
        this.props.openError(
          translateWebMessages('File Too Small, Min 5000; this file:: 0'),
          undefined,
          undefined,
          () => {
            this.setState({
              signedPdf: false,
              FileName: '',
              file: null,
            })
          },
        )
        return
      }
      try {
        const { mime } = await fromBuffer(arrayBuffer)
        if (MimeTypes[fileExt] === mime) {
          this.setState(
            {
              signedPdf: false,
              FileName: event.target.value.split(/(\\|\/)/g).pop(),
              file: null,
            },
            () => {
              this.props.form.validate()
            },
          )
        } else {
          this.props.openError('file type not supported', undefined, undefined, () => {
            this.setState({
              signedPdf: false,
              FileName: '',
              file: null,
            })
          })
        }
      } catch (error) {
        this.props.openError('file type not supported', undefined, undefined, () => {
          this.setState({
            signedPdf: false,
            FileName: '',
            file: null,
          })
        })
      }
    }
  }

  saveFileInputRef = (input) => {
    this.fileInput = input
  }

  handleFileTypeChanged = async () => {
    const Title = this.FileTypes.find((t) => t.value === this.props.form.values.FileTypeID).text

    this.props.form.changeValues({
      Title,
    })

    const result = await this.props.convertUnicodeToLatin(Title)
    if (convertUnicodeToLatin.fulfilled.match(result)) {
      this.props.form.changeValue('Title_ALT', result.payload)
    }
  }

  handleElSign = async () => {
    this.setState({
      isLoading: true,
    })
    try {
      await Files.personalNoCheck(this.props.PersonalNo)
      this.pdfSign()
    } catch (err) {
      this.setState(
        {
          isLoading: false,
        },
        () => {
          this.props.openError(translateLKMessage(err.Error ? err.Error.Text || err.Error.Message : 'HINT_ERR_TITLE'))
        },
      )
    }
  }

  pdfSign = () => {
    const file = this.state.file || this.fileInput.files[0]

    const reader = new FileReader()

    reader.onloadend = async () => {
      try {
        const response = await Files.signPdf({
          PersonalNo: this.props.PersonalNo,
          PdfFile: (reader.result as string).split(',')[1],
        })

        const resData = await response.json()

        if (resData.Error && (resData.Error.Message || resData.Error.Text)) {
          throw resData
        }

        const PdfUrl = `data:application/pdf;base64,${resData.Data.File}`

        const fileFromUrl = await Files.urlToFile(PdfUrl, 'signed.pdf', 'pdf')
        this.setState({
          signedPdf: true,
          isLoading: false,
          file: fileFromUrl,
        })
      } catch (e) {
        this.setState(
          {
            isLoading: false,
          },
          () => {
            this.props.openError(translateLKMessage(e.Error ? e.Error.Text || e.Error.Message : 'HINT_ERR_TITLE'))
          },
        )
      }
    }

    reader.readAsDataURL(file)
  }

  render() {
    const { modalInstanceName, form, params } = this.props
    const { submitting, errors } = form

    const { scanning, signedPdf } = this.state
    return (
      // @ts-ignore
      <LKModal
        icon="paperclip"
        name={modalInstanceName}
        heading={translate('frm_lfl_file_add_edit')}
        size="xs"
        footer={
          // @ts-ignore
          <LKModal.Footer>
            <LKButton.Okay onClick={this.handleSubmit} disabled={submitting} loading={submitting} />
            {/** @ts-ignore */}
            <LKModal.CancelButton disabled={submitting} text={translate('cmd_cancel')} />
            {/** @ts-ignore */}
          </LKModal.Footer>
        }
        noOverflow
      >
        <Wrapper>
          <GridContainer>
            <Grid columns={4}>
              <Grid.Row>
                <Grid.Column />
                <Grid.Column>
                  {/* @ts-ignore */}
                  <FormField
                    type="checkbox"
                    name="Active"
                    label={translate('chk_active')}
                    form={form}
                    disabled={!this.props.params.ID}
                  />
                </Grid.Column>
                <GridColumn>
                  {/* @ts-ignore */}
                  <FormField
                    disabled={this.props.params.ID || !this.props.CanChangeVisa}
                    type="checkbox"
                    name="Visa"
                    label={Translate('frm_collateral_view-cmd_collateral_visa')}
                    form={form}
                  />
                </GridColumn>
              </Grid.Row>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">
                  {signedPdf && <LKIcon alias="ok" size={30} />}

                  <span>{translate('lbl_filename')}</span>
                </Grid.Column>
                <Grid.Column className="u-flex u-directionRow u-alignCenter u-pullRight" style={{ width: '75%' }}>
                  <FakeInput style={{ flex: 1, overflow: 'hidden', whiteSpace: 'nowrap' }}>
                    <Segment style={{ padding: 0 }}>
                      <LKHeader
                        style={{
                          whiteSpace: 'nowrap',
                          overflowX: 'auto',
                          lineHeight: '21px',
                          padding: 7,
                          paddingBottom: 0,
                          color: !scanning && errors.FileData1 ? colors.red : undefined,
                        }}
                      >
                        {(!scanning && form.touched.FileData1 && errors.FileData1) || this.state.FileName}
                      </LKHeader>
                    </Segment>
                  </FakeInput>

                  <input
                    type="file"
                    accept=".xls,.xlsx,.jpg,.pdf,.doc,.docx,.rtf"
                    id="file"
                    style={{ display: 'none' }}
                    onChange={this.handleFileChange}
                    ref={this.saveFileInputRef}
                  />

                  <LKButton alias="ellipsis" onClick={this.handleUpload} disabled={!!params.ID || scanning} />

                  {/* <LKButton
                    alias="scan"
                    onClick={this.handleScan}
                    loading={scanning}
                    disabled={!!params.ID || scanning}
                  /> */}

                  {/* <LKButton
                    alias="edit"
                    loading={this.state.isLoading}
                    onClick={this.handleElSign}
                    disabled={last(this.state.FileName.split('.')) !== 'pdf' || this.state.isLoading || signedPdf}
                  >
                    {translateLKMessage('cmd_sign')}
                  </LKButton> */}
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translate('lbl_type')}</Grid.Column>
                <Grid.Column className="u-flex u-directionRow u-alignCenter" style={{ width: '75%' }}>
                  {/* @ts-ignore */}
                  <FormField
                    type="select"
                    name="FileTypeID"
                    form={form}
                    options={this.FileTypes}
                    onChanged={this.handleFileTypeChanged}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translate('lbl_title')}</Grid.Column>
                <Grid.Column className="u-flex u-directionRow u-alignCenter" style={{ width: '75%' }}>
                  {/* @ts-ignore */}
                  <FormField type="text" name="Title" form={form} onBlur={this.onTranslateAltRequest} maxLength="200" />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="right">{translate('lbl_title_alt')}</Grid.Column>
                <Grid.Column className="u-flex u-directionRow u-alignCenter" style={{ width: '75%' }}>
                  {/* @ts-ignore */}
                  <FormField type="text" name="Title_ALT" form={form} maxLength="200" />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Wrapper>
      </LKModal>
    )
  }
}

export default FileUpload
